import { render } from "./NoteGroup.vue?vue&type=template&id=3d9c7266&scoped=true"
import script from "./NoteGroup.vue?vue&type=script&lang=js"
export * from "./NoteGroup.vue?vue&type=script&lang=js"

import "./NoteGroup.vue?vue&type=style&index=0&id=3d9c7266&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9c7266"]])

export default __exports__